module.exports = __webpack_public_path__ + "media/music/8c0c02f16572b730d422f96a3ce53e7f.mp3";